import styled from 'styled-components';
var CardStyle = styled.div.withConfig({
  displayName: "Cardstyles__CardStyle",
  componentId: "pantheon__sc-1o9mrwb-0"
})(["display:inline-block;background-color:#ffff;min-height:400px;min-width:250px;box-shadow:rgba(0,0,0,0.3) 0px 2px 10px 0px;"]);
export { CardStyle };